/* GETARENIX UI: finger-swipe carousels with dots + play only the visible video */
(function(){
  function center(el){ var r = el.getBoundingClientRect(); return r.left + r.width / 2; }
  function setup(c){
    if (c.getAttribute('data-gx')) return;
    c.setAttribute('data-gx', '1');
    var tr = c.querySelector('.cx-car__track');
    if (!tr) return;
    var items = Array.prototype.slice.call(tr.children);
    if (!items.length) return;
    items.forEach(function(it){ it.querySelectorAll('img').forEach(function(im){ im.setAttribute('draggable', 'false'); }); });
    var cur = 0;
    var dots = document.createElement('div');
    dots.className = 'cx-dots';
    function setDots(i){ Array.prototype.forEach.call(dots.children, function(d, k){ d.classList.toggle('is-on', k === i); }); }
    function go(i){
      i = Math.max(0, Math.min(items.length - 1, i));
      cur = i;
      var delta = center(items[i]) - center(tr);
      tr.scrollTo({ left: tr.scrollLeft + delta, behavior: 'smooth' });
      setDots(i);
    }
    if (items.length > 1) {
      items.forEach(function(it, i){
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'cx-dot' + (i === 0 ? ' is-on' : '');
        d.setAttribute('aria-label', 'Slide ' + (i + 1));
        d.addEventListener('click', function(){ go(i); });
        dots.appendChild(d);
      });
      var nav = c.querySelector('.cx-car__nav');
      c.insertBefore(dots, nav || null);
      if (nav) {
        nav.querySelectorAll('.cx-car__btn').forEach(function(b){
          b.addEventListener('click', function(e){
            e.stopImmediatePropagation();
            go(cur + (b.getAttribute('data-dir') === 'prev' ? -1 : 1));
          }, true);
        });
      }
    }
    var ticking = false;
    tr.addEventListener('scroll', function(){
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function(){
        ticking = false;
        if (dragging) return;
        var mid = center(tr), best = 0, bd = 1e9;
        items.forEach(function(it, i){ var d = Math.abs(center(it) - mid); if (d < bd) { bd = d; best = i; } });
        cur = best;
        setDots(best);
      });
    }, { passive: true });

    var dragging = false, locked = null, sx = 0, sy = 0, sl = 0, dx = 0, st = 0;
    tr.addEventListener('pointerdown', function(e){
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; locked = null; dx = 0;
      sx = e.clientX; sy = e.clientY; sl = tr.scrollLeft; st = Date.now();
      if (e.pointerType === 'mouse' && tr.setPointerCapture) { try { tr.setPointerCapture(e.pointerId); } catch(err){} }
    });
    tr.addEventListener('pointermove', function(e){
      if (!dragging) return;
      dx = e.clientX - sx;
      var dy = e.clientY - sy;
      if (locked === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) { locked = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y'; }
      if (locked === 'x') { tr.scrollLeft = sl - dx; }
    });
    function end(){
      if (!dragging) return;
      dragging = false;
      if (locked !== 'x') return;
      var fast = Math.abs(dx) / Math.max(1, Date.now() - st) > 0.35;
      if (dx < -40 || (fast && dx < -10)) { go(cur + 1); }
      else if (dx > 40 || (fast && dx > 10)) { go(cur - 1); }
      else { go(cur); }
    }
    tr.addEventListener('pointerup', end);
    tr.addEventListener('pointercancel', end);
    tr.addEventListener('lostpointercapture', end);
    window.addEventListener('resize', function(){ go(cur); });
  }
  function init(){
    document.querySelectorAll('.cx-car').forEach(setup);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(es){
        es.forEach(function(e){
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio > 0.55) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
          else { v.pause(); }
        });
      }, { threshold: [0, 0.55, 1] });
      document.querySelectorAll('.cx-car__item--vid video').forEach(function(v){
        if (v.getAttribute('data-gx')) return;
        v.setAttribute('data-gx', '1');
        v.muted = true;
        v.setAttribute('playsinline', '');
        io.observe(v);
      });
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
